import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BasePlainResource } from "./BasePlainResource";
import { paramsToString } from "../resources/BaseResource";
class CustomerSignatureInfoResource extends BasePlainResource {
    constructor() {
        super(...arguments);
        this.signerStatusMessage = "";
        this.customerSignersHTML = "";
    }
    pk() {
        return (this.applicationNumber?.toString() + "-" + this.signerType?.toString());
    }
    static url(urlParams) {
        return `${this.urlRoot}${paramsToString(urlParams)}`;
    }
}
CustomerSignatureInfoResource.urlRoot = legacyApiResourceUrl("Signer/GetCustomerSignatureInfo");
export { CustomerSignatureInfoResource };
//# sourceMappingURL=CustomerSignatureInfoResource.js.map